import React, { useState } from 'react';
import { FaFilePdf, FaShareAlt, FaFileAlt } from 'react-icons/fa';

function MyDocuments() {
  // Sample data for verified documents
  const [documents, setDocuments] = useState([
    { id: 1, name: 'VerifiedDoc1.pdf', verified: true },
    { id: 2, name: 'VerifiedDoc2.docx', verified: true },
    { id: 3, name: 'VerifiedDoc3.xlsx', verified: true },
  ]);

  // Function to export document as PDF
  const exportAsPDF = (id) => {
    // This will be replaced by backend integration in the future
    alert(`Document with ID ${id} exported as PDF`);
  };

  // Function to share document access
  const shareAccess = (id) => {
    // This will be replaced by backend integration in the future
    alert(`Access to document with ID ${id} shared`);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 flex flex-col items-center">
      <div className="w-full max-w-3xl bg-white shadow-lg rounded-lg p-4">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">My Verified Documents</h2>
        <div className="border-t border-gray-200">
          {documents.length > 0 ? (
            <ul className="divide-y divide-gray-200">
              {documents.map((doc) => (
                <li key={doc.id} className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4">
                  <div className="flex items-center mb-2 sm:mb-0">
                    <FaFileAlt className="text-gray-400 mr-2" />
                    <span className="text-gray-700">{doc.name}</span>
                  </div>
                  <div className="flex space-x-2">
                    <button
                      onClick={() => exportAsPDF(doc.id)}
                      className="text-green-500 hover:text-green-700 flex items-center"
                    >
                      <FaFilePdf className="mr-1" /> Export as PDF
                    </button>
                    <button
                      onClick={() => shareAccess(doc.id)}
                      className="text-blue-500 hover:text-blue-700 flex items-center"
                    >
                      <FaShareAlt className="mr-1" /> Share Access
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-600 text-center py-6">No verified documents.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default MyDocuments;
